<template>
  <el-dialog
    title="商户信息"
    :visible.sync="dialogVisible"
    destroy-on-close
    :before-close="handleDialogClose"
  >
    <el-form
      ref="businessUserForm"
      label-width="auto"
      :model="businessUser"
      :label-position="position"
      :rules="businessUserRules"
      required-asterisk
      center
    >
      <el-row>
        <el-col :span="12">
          <el-form-item required label="用户" prop="name">
            <el-input
              v-model="businessUser.name"
              placeholder="用户"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="手机号" prop="phone">
            <el-input
              v-model="businessUser.phone"
              placeholder="手机号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="businessUser.address"
              placeholder="地址"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item required label="openid" prop="openid">
            <el-input
              v-model="businessUser.openid"
              placeholder="openid"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="unionid" prop="unionid">
            <el-input
              v-model="businessUser.unionid"
              placeholder="unionid"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="appid" prop="appid">
            <el-input
              v-model="businessUser.appid"
              placeholder="appid"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item required label="工程师" prop="engineerId">
            <el-input
              v-model="businessUser.engineerId"
              placeholder="工程师"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="memo">
            <el-input
              v-model="businessUser.memo"
              placeholder="备注"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否要支付" prop="payFlag">
            <el-switch
              v-model="businessUser.payFlag"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
              active-text="是"
              inactive-text="否"
            >
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手艺人类型" prop="craftsmanType">
            <!-- <el-switch
              v-model="businessUser.craftsmanType"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="0"
              inactive-value="5"
              active-text="金牌手艺人"
              inactive-text="爱回收手艺人"
            >
            </el-switch> -->
            <el-select
              v-model="businessUser.craftsmanType"
              placeholder="请选择"
            >
              <el-option label="金牌手艺人" value="0"></el-option>
              <el-option label="爱回收手艺人" value="5"></el-option>
              <el-option label="爱回收保险手艺人" value="7"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handlerSave" size="medium"
        >保存</el-button
      >
      <el-button size="medium" @click="handleDialogClose">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { businessUserSave, businessUserUpdate } from "../../../../api/api";
import {
  showLoading,
  hideLoading
} from "../../../../components/loading/loading";
export default {
  name: "BusinessUserEdit",
  data() {
    return {
      mode: "add",
      businessUser: {},
      position: "left",
      businessUserRules: {
        name: [
          {
            required: true,
            message: "请输入用户",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ],
        openid: [
          {
            required: true,
            message: "请输入openid",
            trigger: "blur"
          }
        ],
        engineerId: [
          {
            required: true,
            message: "请输入工程师",
            trigger: "blur"
          }
        ]
      },
      dialogVisible: false
    };
  },
  mounted() {},
  methods: {
    open(mode, target) {
      this.mode = mode;
      if (mode == "add") {
        this.addNew(target);
      } else {
        this.update(target);
      }
      this.dialogVisible = true;
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    addNew(target) {
      this.businessUser = {
        id: undefined,
        payFlag: "1",
        craftsmanType: "0"
      };
    },
    update(target) {
      this.businessUser = target;
    },
    handlerSave() {
      let _self = this;
      this.$refs.businessUserForm.validate(valid => {
        if (valid) {
          if (_self.mode === "add") {
            _self.save();
          } else {
            _self.updateById();
          }
        } else {
          this.$message.error("表单校验失败，请检查");
        }
      });
    },
    save() {
      let _self = this;
      showLoading();
      businessUserSave(this.businessUser)
        .then(res => {
          if (res.data.status == 100) {
            _self.$message.success(res.data.message);
            _self.$emit("ok");
            _self.handleDialogClose();
          } else {
            _self.$message.warning(res.data.message);
          }
        })
        .finally(() => {
          hideLoading();
        });
    },
    updateById() {
      let _self = this;
      showLoading();
      businessUserUpdate(this.businessUser)
        .then(res => {
          if (res.data.status == 100) {
            _self.$message.success(res.data.message);
            _self.$emit("ok");
            _self.handleDialogClose();
          } else {
            _self.$message.warning(res.data.message);
          }
        })
        .finally(() => {
          hideLoading();
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?953cc3d8